<app-full-page-message
  *ngIf="businessId && businessId.length > 5 && !localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)" />
<div
  *ngIf="!businessId || businessId.length <5 || localService.isUserHasBusinessRole(businessId,RelationShipRole.Admin)">
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.product_categories">
    <app-business-deductive *ngIf="businessId != '' && businessId != '0'" [currentBusinessId]="businessId"
      [businesses]="localService.loggedMember.businesses"></app-business-deductive>
    <div class="banner center" style="max-width:600px;">
      <div class="row row_header freeze_height">
        <div class="col-12" style="text-align: left;">
          <label style="font-weight: normal; margin-left: 15px;">
            <input type="checkbox" [(ngModel)]="isShowDeleted" (change)="onLoad()" />
            <span class="normal_color">{{localService.languageContent.product_categories.show_deleted}}</span>
          </label>
          <div class="icon_action_header">
            <i class="material-icons on_language_changed" (click)="onLoad()">refresh</i>
            <i class="material-icons" (click)="openProductCategory()"
              title="{{localService.languageContent.common.add}}">note_add</i>
          </div>
        </div>
      </div>
      <div class="custom_rows_body" *ngIf="items" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
        <div class="row styled_row" *ngFor="let item of items">
          <div class="col-2">
            <i class="material-icons icon_adjust" (click)="onRemove(item.key)" [ngClass]="{
              'delete_icon': item.v3 =='1'
              }">
              {{item.v3 =='1' ? 'cancel' : 'restore'}}
            </i>
          </div>
          <div class="col-10">
            <span class="button" (click)="openProductCategory(item.key)"
              [ngClass]="localService.getLanguageCode(item.v2)">{{item.v1}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>